/**
 * Available game attributes
 */
export enum GameAttribute {
  NEW = 32,
  HOT = 33,
  TOP = 87,
  TOURNAMENT = 35,
  JACKPOT = 36,
  FS = 37,
  FLASH = 31,
  ADAPTIVE_FLASH = 24,
  LIVE = 27,
  NODEMO = 26,
  DAILY_DROPS = 68,
  BITCOIN = 70,
  PRE_RELEASE = 147,
  POPULAR = 149,
}
